import React from 'react';
import { styled } from 'styled-components';

import { Media } from '../../../theme/Media.tsx';
import { useTableContext } from '../context.tsx';
import TbodySeparator from '../TbodySeparator.tsx';
import Td from '../Td.tsx';
import Tr from '../Tr.tsx';
import { headerDropContext } from './DndContext.ts';

export const Header = styled.tbody<{ $isCollapsedNav?: boolean }>`
  + tbody > tr:first-child > td {
    @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
      border-top: 2px solid ${({ theme }) => theme.colors.grey30_1};
    }
  }
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.mdMax : Media.lgMax)} {
    display: flex;
    justify-content: space-between;
    width: 100%;
    > tr {
      width: 100%;
      margin: 0 0 -3px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Title = styled.div`
  padding: 5px 14px;
  background: ${({ theme }) => theme.colors.grey30_1};
  border-radius: 4px 4px 0 0;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const TitleGroup = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const Summary = styled.div<{ $isCollapsedNav?: boolean }>`
  font-weight: 500;
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
    padding: 0 14px;
  }
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
`;

export interface ITbodyHeader {
  name: React.ReactNode;
  nameAdditional?: React.ReactNode;
  summary?: React.ReactNode;
  actions?: React.ReactNode;
  dataTestId?: string;
}

const TbodyHeader: React.FC<ITbodyHeader> = ({ name, nameAdditional, summary, actions, dataTestId }) => {
  const { isCollapsedNav } = useTableContext();
  const header = React.useContext(headerDropContext);
  return (
    <>
      <TbodySeparator />
      <Header ref={header} $isCollapsedNav={isCollapsedNav}>
        <Tr>
          <Td type='sub' bgColor='transparent'>
            <Content>
              <TitleGroup>
                <Title data-testid={dataTestId}>{name}</Title>
                {nameAdditional}
              </TitleGroup>
              {(summary || actions) && (
                <RightSide>
                  {summary && <Summary $isCollapsedNav={isCollapsedNav}>{summary}</Summary>}
                  {actions}
                </RightSide>
              )}
            </Content>
          </Td>
        </Tr>
      </Header>
    </>
  );
};

export default TbodyHeader;
